// core components/views for Admin layout

import Dashboard from "views/Dashboard/Dashboard";
import Assessments from "views/Assessments";
import KnowledgeBase2 from "views/KnowledgeBase2";
import LoanLandingPage from "views/Loan";
import GuidesPage from "views/Guides/GuidesPage.jsx";
//import AnalyticsPage from "views/Analytics/AnalyticsPage.jsx";
import AnalyticsIdeas from "views/Analytics/AnalyticsIdeas/AnalyticsIdeas.jsx";
import AnalyticsCompany from "views/Analytics/AnalyticsCompany/AnalyticsCompany.jsx";
import AnalyticsExercise from "views/Analytics/AnalyticsCompany/AnalyticsExercise.jsx";
import UserProfile from "views/UserProfile/UserProfile.jsx";
import Analytics_CompletionLog from"views/Analytics/AnalyticsCompletion/AnalyticsCompletionLogPage.jsx";
import HelpPage from "views/Help/HelpPage.jsx";
import MyActionsPage from "views/MyActions/MyActionsPage.jsx";
import KnowledgeBasePage from "views/KnowledgeBase/KnowledgeBasePage.jsx";
import ConsultRamboll from "views/ConsultRamboll/index.jsx";
import Marketing from "views/Marketing/index.jsx";
import ContactRamboll from "views/ContactRamboll/index.jsx";

//custom icon images
import DashboardIcon from "assets/img/navbar/DashboardIcon.png";
import DashboardIconBlack from "assets/img/navbar/DashboardIconBlack.png";
import AnalyticsIcon from "assets/img/navbar/AnalyticsIcon.png";
import AnalyticsIconBlack from "assets/img/navbar/AnalyticsIconBlack.png";
import ElearningIcon from "assets/img/navbar/ModuleIcon.png";
import ElearningIconBlack from "assets/img/navbar/ModuleIconBlack.png";
import Knowledgebase from "assets/img/navbar/KnowledgebaseIcon.png";
import KnowledgebaseBlack from "assets/img/navbar/KnowledgebaseIconBlack.png";
import MyActivites from "assets/img/navbar/MyActivityIcon.png";
import MyActivitiesIconBlack from "assets/img/navbar/MyActivityIconBlack.png";
import MyActions from "assets/img/navbar/MyactionsIcon.png";
import MyActionsBlack from "assets/img/navbar/MyactionsIconBlack.png";
import ContactUs from "assets/img/navbar/LetterIcon.png";
import ContactUsBlack from "assets/img/navbar/LetterIconBlack.png";
import Logout from "assets/img/navbar/LogoutIcon.png";
import LogoutIconBlack from "assets/img/navbar/LogoutIconBlack.png";
import AssessmentsIcon from "assets/img/navbar/AssessmentsIcon.png";
import AssessmentsIconBlack from "assets/img/navbar/AssessmentsIconBlack.png";
import LoanIconBlack from "assets/img/navbar/LoanIconBlack.png";
import LoanIcon from "assets/img/navbar/LoanIcon.png";
import ConsultRambollBlackIcon from "assets/img/navbar/ConsultRambollBlack.png";
import ConsultRambollIcon from "assets/img/navbar/ConsultRamboll.png";
import MarketingIcon from "assets/img/navbar/MarketingIcon.png";
import MarketingIconActive from "assets/img/navbar/MarketingIconActive.png";
import ContactRambollIcon from "assets/img/conversation.png"
import ContactRambollBlackIcon from "assets/img/conversation-black.png";


import analytics_submenu from "assets/img/analytics_submenu.png"

import i18n from "i18next";
import AnalyticsOverview from "views/Analytics/Analytics_Overview";
import UserActions from "views/Analytics/UserActions";
import UserProfileV2 from "views/UserProfileV2";
import CompletionLog from "views/Analytics/CompletionLog";
import BusinessIdeas from "views/Analytics/BusinessIdea";
// core components/views for RTL layout

const kbName = "Knowledge base";

let dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    trans: i18n.t("Dashboard"),
    icon: [DashboardIconBlack, DashboardIcon],
    component: Dashboard,
    roleD: "Both",
    submenu: false,
    layout: "/admin",
  },
  {
    path: "/guides/:id",
    name: "E-learnings",
    trans: i18n.t("E-Learnings"),
    icon: [ElearningIconBlack, ElearningIcon],
    component: GuidesPage,
    roleD: "Both",
    submenu: false,
    layout: "/admin"
  },
  {
    path: "/assessments",
    name: "Assessments",
    trans: i18n.t("Assessments"),
    icon: [AssessmentsIconBlack, AssessmentsIcon],
    component: Assessments,
    roleD: "Both",
    submenu: false,
    layout: "/admin"
  },
  {
    path: "/loan",
    name: "Loan",
    trans: i18n.t("Loan"),
    icon: [LoanIconBlack, LoanIcon],
    component: LoanLandingPage,
    roleD: "Both",
    submenu: false,
    layout: "/admin"
  },
  {
    path: "/knowledgebase",
    name: kbName,
    trans: i18n.t("Knowledge Base"),
    icon: [KnowledgebaseBlack, Knowledgebase],
    component: KnowledgeBase2,
    roleD: "Both",
    submenu: false,
    layout: "/admin"
  },
  {
    path: "/my_actions",
    name: "My Actions",
    trans: i18n.t("My Actions"),
    icon: [MyActionsBlack, MyActions],
    component: MyActionsPage,
    roleD: "Manager",
	permissionAnalytics: true,
    submenu: false,
    layout: "/admin"
  },
  // {
  //   path: "/analytics_overview",
  //   name: "Analytics",
  //   trans: i18n.t("Analytics"),
  //   icon: [AnalyticsIconBlack, AnalyticsIcon],
  //   component: AnalyticsPage,
  //   roleD: "Manager",
	// permissionAnalytics: true,
  //   submenu: false,
  //   layout: "/admin"
  // },
  {
    path: "/analytics_overview_lmanager",
    name: "Analytics",
    trans: i18n.t("Analytics"),
    icon: [AnalyticsIconBlack, AnalyticsIcon],
    component: AnalyticsOverview,
    roleD: "Manager",
	  permissionAnalytics: true,
    submenu: false,
    layout: "/admin"
  },
  {
    path: "/analytics_user_actions",
    name: "User actions",
    trans: i18n.t("User actions"),
    icon: "content_paste",
    component: UserActions,
    roleD: "Manager",
	  permissionAnalytics: true,
    layout: "/admin",
    submenu: true,
    invisible: true
  },
  {
    path: "/analytics_completion",
    name: "Completion log",
    trans: i18n.t("Completion Log"),
    icon: "content_paste",
    component: CompletionLog,
    roleD: "Manager",
	  permissionAnalytics: true,
    layout: "/admin",
    submenu: true,
    invisible: true
  },

    {
    path: "/analytics_business_ideas",
    name: "Business ideas",
    trans: i18n.t("Business ideas"),
    icon: "content_paste",
    component: BusinessIdeas,
    roleD: "Manager",
	  permissionAnalytics: true,
    layout: "/admin",
    submenu: true,
    invisible: true
  },

  {
    path: "/analytics_completion_old",
    name: "Old Completion log",
    trans: i18n.t("Completion Log"),
    icon: "content_paste",
    component: Analytics_CompletionLog,
    roleD: "Manager",
	  permissionAnalytics: true,
    layout: "/admin",
    submenu: true,
    invisible: true
  },

  {
    path: "/analytics_company",
    name: "Employee feedback",
    trans: i18n.t("Company Analytics"),
    icon: analytics_submenu,
    component: AnalyticsCompany,
    roleD: "Manager",
	permissionAnalytics: true,
    layout: "/admin",
    submenu: true,
    invisible: true
  },
  {
    path: "/analytics_ideas/:archived",
    name: "Archived Ideas and comments",
    trans: i18n.t("Archived Ideas and comments"),
    icon: "content_paste",
    component: AnalyticsIdeas,
    subpage: true,
    roleD: "Manager",
	permissionAnalytics: true,
    layout: "/admin",
    submenu: false,
    invisible: true
  },
  {
    path: "/analytics_ideas",
    name: "Ideas and comments",
    trans: i18n.t("Ideas and comments"),
    icon: analytics_submenu,
    component: AnalyticsIdeas,
    subpage: false,
    roleD: "Manager",
	permissionAnalytics: true,
    layout: "/admin",
    submenu: true,
    invisible: true
  },

  {
    path: "/custom_activity/:exerciseid",
    name: "Analytics",
    trans: i18n.t("Analytics"),
    icon: "content_paste",
    component: AnalyticsExercise,
    subpage: true,
    roleD: "Manager",
	permissionAnalytics: true,
    layout: "/admin",
    submenu: false,
    invisible: true
  },
  {
  path: "/marketing",
  name: "Email users",
  trans: i18n.t("Email users"),
  icon: [MarketingIcon, MarketingIconActive],
  component: Marketing,
  roleD: "Both",
  submenu: false,
  layout: "/admin"
},
  {
    path: "/consult-ramboll",
    name: "Consult Ramboll",
    component: ConsultRamboll,
    roleD: "Both",
    icon: [ConsultRambollBlackIcon, ConsultRambollIcon],
    layout: "/admin",
  },
  {
    path: "/profile",
    name: i18n.t("My profile"),
    trans: i18n.t("My profile"),
    icon: [MyActivitiesIconBlack, MyActivites],
    component: UserProfileV2,
    roleD: "Both",
    submenu: false,
    layout: "/admin"
  },
  {
    path: "/contact-support",
    name: i18n.t("Contact support"),
    trans: i18n.t("Contact support"),
    icon: [ContactUsBlack, ContactUs],
    component: ContactRamboll,
    roleD: "Both",
    submenu: false,
    layout: "/admin"
  },
  {
    path: "/logout",
    name: "Logout",
    trans: i18n.t("Logout"),
    icon: [LogoutIconBlack, Logout],
    component: HelpPage,
    roleD: "Both",
    submenu: false,
    layout: "/admin"
  }

];

//get from localstorage
if (localStorage.getItem("is_kbarray") !== null ) {
	let kbroutes = localStorage.getItem("is_kbarray");
	let kbarray = JSON.parse(kbroutes);
	if (kbarray !== undefined && kbarray.length > 0) {
		const indexKB = dashboardRoutes.findIndex(el => el.name === kbName);
    console.log("Dashboard routes", dashboardRoutes);
    console.log("Knowledge Base array", kbarray);
    console.log("Index of Knowledge Base", indexKB);
		dashboardRoutes[indexKB].id = "";
		kbarray.reverse().map((obj, index) => {
			let newrt = {
				path: "/knowledgebasesub",
				id: obj.id,
				name: obj.name,
				nameGen: "Knowledge Base Sub",
				trans: i18n.t("Knowledge Base Sub"),
				icon: analytics_submenu,
				component: KnowledgeBasePage,
				roleD: "Both",
				norder: index,
				layout: "/admin",
				submenu: true,
				submenuKB: true,
				invisible: true
			};
			dashboardRoutes = [...dashboardRoutes.slice(0, indexKB+1), newrt, ...dashboardRoutes.slice(indexKB+1)];
		});
	}
}

//get from localstorage
/*if (localStorage.getItem("is_compside") !== null ) {
	let moDroutes = localStorage.getItem("is_compside");
	let mdarray0 = JSON.parse(moDroutes);
  let mdarray = mdarray0.modCategories;
  console.log("side menu", mdarray);
	if (mdarray !== undefined && mdarray.length > 0) {
    const indexMOD = dashboardRoutes.findIndex(el => el.name === "E-Learnings");
		dashboardRoutes[indexMOD].id = "";
		mdarray.reverse().map((obj, index) => {
			let newrt = {
				path: "/guides",
				id: obj.id,
				name: obj.name,
				nameGen: "E-Learnings sub",
				trans: i18n.t("E-Learnings"),
				icon: [ElearningIconBlack, ElearningIcon],
				component: GuidesPage,
				roleD: "Both",
				layout: "/admin",
				submenu: true,
				invisible: true
			};
			dashboardRoutes = [...dashboardRoutes.slice(0, indexMOD+1), newrt, ...dashboardRoutes.slice(indexMOD+1)];
		});
	}
}*/

export default dashboardRoutes;